import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="panel-actions"
// Toggles the visibility of a row of event-level actions in the dashboard
// event panel. Chevron rotates 180° when open.
export default class extends Controller {
  static targets = ["actions"]

  toggle(event) {
    event.preventDefault()
    const button = event.currentTarget
    const isOpen = !this.actionsTarget.hidden
    this.actionsTarget.hidden = isOpen
    button.setAttribute("aria-expanded", String(!isOpen))
    this.element.classList.toggle("is-open", !isOpen)
  }
}
